import { useEffect, useMemo, useCallback, useRef } from 'react';
import { message, Spin } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '@/store';
import Utils from '@/utils/utils';
import RtcClient from '@/lib/RtcClient';
import ResizeWrapper from '@/components/ResizeWrapper';
import Conversation from './Conversation';
import { useGetDevicePermission, useJoin, useLeave } from '@/lib/useCommon';
import { setDevicePermissions } from '@/store/slices/device';
import styles from './index.module.less';
import { get } from '@/utils/request';

function View() {
  //状态管理
  const dispatch = useDispatch();
  //路由跳转
  const navigate = useNavigate();
  //房间信息
  const room = useSelector((state: RootState) => state.room);

  /**
   * 获取用户设备权限
   */
  useGetDevicePermission();

  //用户加入房间、离开房间
  const [joining, disPatchJoin] = useJoin();
  const leave = useLeave();

  const ref = useRef({
    publishAudio: room.localUser.publishAudio,
  });

  //是否登录
  const hasLogin = useMemo(() => Utils.checkLoginInfo(), []);


  useEffect(() => {
    //验证是否登录
    get('/ums/web/auth/login/checkLogin', {}).then((res) => {
      console.log(res.data);
      if (res.code === 200) {
        //用户未登录
        if (!res.data) {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('userInfo');
          //导航到路由页，进行登录
          navigate('/router');
          return;
        } else {
          if (!room.roomId && !hasLogin) {
            //房间不存在
            const roomId = Utils.getUrlArgs()?.roomId;
            const userId = Utils.getUrlArgs()?.userId;
            if (roomId) {
              if (userId) {
                navigate(`/router?roomId=${roomId}&userId=${userId}`);
              } else {
                navigate(`/router?roomId=${roomId}`);
              }
            } else {
              navigate('/router');
            }
          } else if (!room.roomId) {
            (async () => {

              //校验用户设备权限
              const permission = await RtcClient.checkPermission();
              dispatch(setDevicePermissions(permission));
              if (!permission) return;

              //获取表单数据
              const formValues = Utils.getLoginInfo();

              //加入房间
              if (permission) {
                disPatchJoin(
                  {
                    ...formValues,
                    publishAudio: permission.audio && JSON.parse(formValues?.publishAudio || 'false'),
                  },
                  true,
                );
              }
            })();
          }
        }
      }
    });
  }, [room.roomId, navigate, hasLogin]);

  useEffect(() => {
    const { publishAudio: prevA } = ref.current;
    const { publishAudio } = room.localUser;

    if (prevA !== publishAudio) {
      ref.current = { publishAudio };
      Utils.setSessionInfo({
        publishAudio: !!publishAudio,
      });
    }
  }, [room.localUser.publishAudio]);

  /**
   * 离开房间
   */
  const leaveRoom = useCallback(() => {
    if (!RtcClient.engine) return;
    leave();
  }, []);

  useEffect(() => {
    window.addEventListener('pagehide', leaveRoom);
    return () => {
      leaveRoom();
      window.removeEventListener('pagehide', leaveRoom);
    };
  }, [leaveRoom]);

  useEffect(() => {
    window.addEventListener('popstate', leaveRoom);
    return () => {
      window.removeEventListener('popstate', leaveRoom);
    };
  }, [leaveRoom]);

  /**
   * rtc成功
   */
  useEffect(() => {
    const stop = async () => {
      await RtcClient.stopAudioBot(room.roomId!, room.localUser.userId!);
    };
    window.addEventListener('beforeunload', stop);
    return () => {
      window.removeEventListener('beforeunload', stop);
    };
  }, [RtcClient]);

  return (
    <Spin spinning={joining}>
      <ResizeWrapper>
        <div className={styles.mainArea}>
          <Conversation />
        </div>
      </ResizeWrapper>
    </Spin>
  );
}

export default View;
